import { DataType } from '../types/data_type';
import { utils } from '../utils/utils';
export var ColumnAlignment;
(function (ColumnAlignment) {
    ColumnAlignment[ColumnAlignment["None"] = 0] = "None";
    ColumnAlignment[ColumnAlignment["Left"] = 1] = "Left";
    ColumnAlignment[ColumnAlignment["Center"] = 2] = "Center";
    ColumnAlignment[ColumnAlignment["Right"] = 3] = "Right";
})(ColumnAlignment || (ColumnAlignment = {}));
var DataColumn = /** @class */ (function () {
    function DataColumn(desc) {
        if (!desc)
            throw Error("Options are required");
        if (!desc.id)
            throw Error("Field Id is required");
        if (!desc.label)
            throw Error("Label is required");
        this.id = desc.id;
        this.type = utils.getIfDefined(desc.type, DataType.String);
        this.label = desc.label;
        this.originAttrId = desc.originAttrId;
        this.isAggr = desc.isAggr || false;
        this.displayFormat = desc.dfmt;
        this.groupFooterColumnTemplate = desc.gfct;
        this.style = desc.style || {};
        this.description = desc.description;
        this.calculatedWidth = 0;
    }
    return DataColumn;
}());
export { DataColumn };
var DataColumnList = /** @class */ (function () {
    function DataColumnList() {
        this.items = [];
        this.mapper = {};
        this._dateColumnIdx = [];
    }
    Object.defineProperty(DataColumnList.prototype, "count", {
        get: function () {
            return this.items.length;
        },
        enumerable: true,
        configurable: true
    });
    DataColumnList.prototype.add = function (colOrDesc) {
        var col;
        if (colOrDesc instanceof DataColumn) {
            col = colOrDesc;
        }
        else {
            col = new DataColumn(colOrDesc);
        }
        var index = this.items.length;
        this.items.push(col);
        this.mapper[col.id] = index;
        if ([DataType.Date, DataType.DateTime, DataType.Time].indexOf(col.type) >= 0) {
            this._dateColumnIdx.push(index);
        }
        return index;
    };
    DataColumnList.prototype.updateDateColumnIdx = function () {
        this._dateColumnIdx = this.getItems()
            .filter(function (col) { return [DataType.Date, DataType.DateTime, DataType.Time].indexOf(col.type) >= 0; })
            .map(function (col, index) { return index; });
    };
    DataColumnList.prototype.put = function (index, col) {
        if (index >= 0 && index < this.count) {
            this.items[index] = col;
            this.updateDateColumnIdx();
        }
    };
    DataColumnList.prototype.move = function (col, newIndex) {
        var oldIndex = this.items.indexOf(col);
        if (oldIndex >= 0 && oldIndex != newIndex) {
            utils.moveArrayItem(this.items, oldIndex, newIndex);
            this.updateDateColumnIdx();
        }
    };
    DataColumnList.prototype.get = function (index) {
        if (index >= 0 && index < this.count) {
            return this.items[index];
        }
        else {
            return null;
        }
    };
    DataColumnList.prototype.getIndex = function (id) {
        return this.mapper[id];
    };
    DataColumnList.prototype.getItems = function () {
        return this.items;
    };
    DataColumnList.prototype.getDateColumnIndexes = function () {
        return this._dateColumnIdx;
    };
    DataColumnList.prototype.removeAt = function (index) {
        var col = this.get(index);
        this.items.splice(index, 1);
        var removeDate = this._dateColumnIdx.indexOf(index);
        if (removeDate >= 0) {
            this._dateColumnIdx.splice(removeDate, 1);
        }
        delete this.mapper[col.id];
    };
    DataColumnList.prototype.clear = function () {
        this.items = [];
        this._dateColumnIdx = [];
        this.mapper = {};
    };
    return DataColumnList;
}());
export { DataColumnList };
//# sourceMappingURL=data_column.js.map